import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
  useMemo
} from 'react';
import { toast } from 'react-toastify';

import { useSelector } from 'react-redux';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  TableFooter,
  Tooltip,
} from '@material-ui/core';
import {
  Search as SearchIcon,
  ChevronLeft,
  ChevronRight,
  Visibility,
} from '@material-ui/icons';
import { isArray, pickBy } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

// import { TextField as Input } from '~/components/Form/v2';
import { t, number } from '~/helpers';
import api from '~/services/api';

import * as S from '../../styles';

import { Container } from './styles';

import Detalhe from '../Detalhe';

function somarColuna(array, coluna) {
  return array.reduce((acc, item) => {
    const valor = parseFloat(item[coluna]);
    if (!isNaN(valor)) {
      return acc + valor;
    }
    return acc;
  }, 0);
}


export default function Card({ params }) {
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const [perPage, setPerPage] = useState(12);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [timeOut, setTimeOut] = useState(0);
  const [search, setSearch] = useState({});

  const [somaCalcCapacidade, setSomaCalcCapacidade] = useState(0);
  const [somaEstoqueUtil, setSomaEstoqueUtil] = useState(0);
  const [somaCalcConsumoMedioDia, setSomaCalcConsumoMedioDia] = useState(0);
  const [somaNumeroCarretas, setSomaNumeroCarretas] = useState(0);

  const [somaVolumeDeSeguraca, setSomaVolumeDeSeguraca] = useState(0);

  const { profile } = useSelector((state) => state.user);
  console.log(profile.username)



  const detalheRef = useRef(null);

  const formRef = useRef(null);

  const currentPage = useMemo(
    () => (Number(page - 1) === 0 ? pageSize : Number(page - 1)),
    [page, pageSize]
  );

  const handleGetResponseAPI = useCallback(async () => {
    try {
      setLoading(true);

      const response = await api.get('/estoquepostomonitor', {
        params: { ...params, ...search, page, pagesize: perPage },
        paramsSerializer: (param) => qs.stringify(param),
      });

      const numPage = response.data.page;
      const totalPage = response.data.totalPages;

      setPage(numPage < totalPage ? Number(numPage + 1) : 1);
      setPageSize(totalPage);
      setData(response.data.items);


      const somacalc_capacidade = somarColuna(response.data.items, 'calc_capacidade');
      setSomaCalcCapacidade(somacalc_capacidade);

      const somaestoque_util = somarColuna(response.data.items, 'calc_estoqueutil');
      setSomaEstoqueUtil(somaestoque_util);

      const somacalc_consumo_medio_dia = somarColuna(response.data.items, 'calc_consumo_medio_dia');
      setSomaCalcConsumoMedioDia(somacalc_consumo_medio_dia);

      const somacalc_numero_carretas = somarColuna(response.data.items, 'calc_numero_carretas_roundtrunk');
      setSomaNumeroCarretas(somacalc_numero_carretas);

      const vlosomaVolumeDeSeguraca = somarColuna(response.data.items, 'calc_volumeporcento80');
      setSomaVolumeDeSeguraca(vlosomaVolumeDeSeguraca);


    } catch (error) {
      if (isArray(error)) error.forEach((err) => toast.error(t(err)));
      else toast.error(t(error));
    } finally {
      setLoading(false);
    }
  }, [params, page, perPage, search]);

  const handleChangeInputPerPage = useCallback(({ target }) => {
    setPerPage(Number(target.value));
    setTimeOut(0);
    setPage(1);
  }, []);

  const handleSubmit = useCallback(async (formData) => {
    try {
      const wherefield = [];
      const valuewherefield = [];
      const typewherefield = [];

      Object.keys(pickBy(formData)).forEach((pick) => {
        wherefield.push(pick);
        valuewherefield.push(formData[pick]);
        typewherefield.push('LIKE');
      });

      setSearch({ wherefield, valuewherefield, typewherefield });
      setTimeOut(0);
      setPage(1);
    } catch (error) {
      if (isArray(error)) error.forEach((err) => toast.error(t(err)));
      else toast.error(t(error));
    }
  }, []);

  const handleKeyPressInput = useCallback(({ key }) => {
    if (key === 'Enter') formRef.current.submitForm();
  }, []);

  const handlegetItem = (item) => {
    if (detalheRef)
      detalheRef.current.handleToggleModal(item);
    console.log(item);
  };

  const handleNextOrPreviewPage = useCallback((number) => {
    setPageSize(0);
    setTimeOut(0);
    setPage(number);
  }, []);

  useEffect(() => {
    setPageSize(0);
    setTimeOut(0);
    setPage(1);
  }, [params]);

  useEffect(() => {
    const isTime = setInterval(() => {
      handleGetResponseAPI();
      setTimeOut(30000);
    }, timeOut);

    return () => clearInterval(isTime);
  }, [handleGetResponseAPI, timeOut]);

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('pt-BR');
  const formattedTime = currentDate.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (

    <>
      <Detalhe ref={detalheRef} name="Detalhe" />

      <S.Container ref={formRef} onSubmit={handleSubmit}>
        {loading && <LinearProgress />}
        {/* <TableContainer component={Paper}> */}

        <S.WrapperContainer component={Paper}>
          {/* <Table stickyHeader> */}
          <div>
            <p>Data: {formattedDate} {formattedTime}</p>
          </div>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <S.CustomTableCell style={{ width: '10rem' }}>Corredor</S.CustomTableCell>
                <TableCell align="left" style={{ width: '15rem' }}>Posto</TableCell>
                <TableCell align="left" style={{ width: '12rem' }}>Capacidade(l)</TableCell>
                <TableCell align="right" style={{ width: '16rem' }}>Estoque útil (l)</TableCell>
                <TableCell align="right" style={{ width: '16rem' }}>Consumo médio/dia (l)</TableCell>
                <TableCell align="right">Duração estoque (dias)</TableCell>
                <TableCell align="right">Espaço vazio (l)</TableCell>
                <TableCell align="right" style={{ width: '16rem' }}>Capacidade Segurança (85%)</TableCell>
                <TableCell align="right" style={{ width: '16rem' }}>Esperado (l)</TableCell>
                <TableCell align="right">Numero Carretas</TableCell>
                <TableCell align="center">Status Transmissão</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item) => (
                <TableRow key={Math.random()}>
                  {/* <TableCell component="th" scope="row"
                  style={{ color: '#ffcbbd', backgroundColor: item.tial_cor }}
                > */}
                  <TableCell className='mayWidh' align="left">
                    {item.corredor}
                  </TableCell>
                  <TableCell className='mayWidh' align="left">{item.posto}</TableCell>
                  {/* <TableCell
                  style={{ color: '#FFFFFF', backgroundColor: item.tial_cor }}
                >
                  {item.aler_nota_mensagem_exibir} 000
                </TableCell> */}
                  <TableCell align="right">
                    {number(item.calc_capacidade, 0)}
                  </TableCell>

                  <TableCell align="right" className='mayWidh'>
                    {number(item.calc_estoqueutil, 0)}
                  </TableCell>

                  <TableCell align="right">
                    {number(item.calc_consumo_medio_dia, 0)}
                  </TableCell>


                  <TableCell align="right" style={{ color: '#FFFFFF', backgroundColor: `${item.calc_duracao_estoque_dias_status}` }}>
                    {number(item.calc_duracao_estoque_dias, 1)}
                  </TableCell>

                  <TableCell align="right">
                    {number(item.calc_espaco_vazio, 0)}
                  </TableCell>

                  <TableCell align="right">
                    {number(item.calc_volumeporcento80, 0)}
                  </TableCell>

                  <TableCell align="right">
                    {number(item.calc_esperado, 0)}
                  </TableCell>

                  <TableCell align="right">
                    {number(item.calc_numero_carretas_roundtrunk, 0)}
                  </TableCell>

                  {
                    item.calc_statuslinha === 'Atrasada' ?
                      (<TableCell className='maySizeStatus' component="th" scope="row" align="center"
                        style={{ color: '#FF0000' }}
                      >{item.calc_statuslinha}</TableCell>) :
                      (<TableCell className='maySizeStatus' component="th" scope="row" align="center"
                        style={{ color: '#008000' }}
                      >{item.calc_statuslinha}</TableCell>)
                  }

                  {((item.mostrarposto === 'S') || (profile.username === 'unidataAdm')) && (
                    <Container size="small" >
                      <Tooltip title={t('s.geral.botaomodelo')}>
                        <IconButton size="small" onClick={() =>
                          handlegetItem(item)
                        }>
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </Container>)}

                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <S.CustomTableCellFooter >Total</S.CustomTableCellFooter >
                <TableCell></TableCell>
                <S.CustomTableCellFooter align="right" >{number(somaCalcCapacidade, 0)} </S.CustomTableCellFooter>
                <S.CustomTableCellFooter align="right" >{number(somaEstoqueUtil, 0)} </S.CustomTableCellFooter>
                <S.CustomTableCellFooter align="right" >{number(somaCalcConsumoMedioDia, 0)}</S.CustomTableCellFooter>
                <TableCell align="right"></TableCell>
                <TableCell align="right"></TableCell>
                <S.CustomTableCellFooter align="right" >{number(somaVolumeDeSeguraca, 0)}</S.CustomTableCellFooter>
                <TableCell align="right"></TableCell>
                <S.CustomTableCellFooter align="right" >{number(somaNumeroCarretas, 0)}</S.CustomTableCellFooter>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableFooter>

          </Table>
        </S.WrapperContainer>

        {/* <S.Pagination >
        <Typography variant="body2">Registros por página:</Typography>

        <TextField
          variant="outlined"
          size="small"
          type="number"
          className="inputPerPage"
          defaultValue={perPage}
          disabled={loading}
          onMouseDown={handleChangeInputPerPage}
          max={99}
          min={1}
        />

        <Typography variant="body2">
          {currentPage} de {pageSize}
        </Typography>

        <S.ButtonGroup>
          <IconButton
            size="small"
            color="default"
            disabled={currentPage === 1 || loading}
            onClick={() => handleNextOrPreviewPage(Number(currentPage - 1))}
          >
            <ChevronLeft />
          </IconButton>

          <IconButton
            size="small"
            color="default"
            disabled={currentPage === pageSize || loading}
            onClick={() => handleNextOrPreviewPage(page)}
          >
            <ChevronRight />
          </IconButton>
        </S.ButtonGroup>
      </S.Pagination> */}

      </S.Container >
    </>
  );
}

Card.propTypes = {
  params: PropTypes.objectOf(PropTypes.any),
};

Card.defaultProps = {
  params: {},
};
